// removed by extract-text-webpack-plugin
module.exports = {"Table":"_1t2D5jK8vuyLYDlHORWUEH","Row":"_3dYMVWt_pzHWCyMrnHzjIC","Link":"_3zhpTwD2zK1DLbuzc9Zjp","Enables":"HtwhtGO75NOVAXfRg7BC4","Disabled":"QJFeZ9TCkgempFY_kOuvS","Payout":"_3xDJwsXDqbZLTdXnoL8wi0","Settings":"_3NLBQZkFDsKArnuBWs0knb","Icon":"_1-afCTDUFNMqElt6Gq5m0C","CellLeft":"_1hD00nfzcDOTu8WbLvp2ip","AmountCell":"_2x1XDiHnG6AoFck6HIoKWC","MobileList":"jZAmjTXl3TErrzoHXBVF6"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ProjectsTable/styles.module.css
// module id = 202
// module chunks = 0